import { Assumptions } from "@justhome/api-core";
import { BudgetCalculatorForm, BudgetResult } from "./types";

export const calculateLoanAmount = (
  availableAmountMonthly: number,
  interestRate: number,
  repaymentRate: number,
): number => {
  return (availableAmountMonthly * 12 * 100) / (interestRate + repaymentRate);
};

const calculateBudget = (
  values: BudgetCalculatorForm,
  assumptions: Assumptions,
): BudgetResult => {
  const realEstateAgentFeePercent =
    assumptions.realEstateAgentFeePercentage ?? 0;
  const propertyTransferTaxPercent =
    assumptions.propertyTransferTaxPercentage ?? 0;
  const notaryFeePercent = 2;
  const safetyCutOffPercent = 5;

  const maxLoan = calculateLoanAmount(
    values.availableAmountMonthly,
    values.interestRate,
    values.repaymentRate,
  );
  const availableAmount = maxLoan + (values.equity || 0);
  const safetyCutOff = (availableAmount * safetyCutOffPercent) / 100;

  const maxPurchasePrice =
    ((availableAmount - safetyCutOff) /
      (100 +
        propertyTransferTaxPercent +
        realEstateAgentFeePercent +
        notaryFeePercent)) *
    100;
  const realEstateAgentFee = Number(
    ((maxPurchasePrice * realEstateAgentFeePercent) / 100).toFixed(2),
  );
  const propertyTransferTax = Number(
    ((maxPurchasePrice * propertyTransferTaxPercent) / 100).toFixed(2),
  );
  const notaryFee = Number(
    ((maxPurchasePrice * notaryFeePercent) / 100).toFixed(2),
  );

  return {
    maxLoan,
    availableAmount,
    notaryFeePercent,
    safetyCutOffPercent,
    propertyTransferTaxPercent,
    realEstateAgentFeePercent,
    maxPurchasePrice: Number(maxPurchasePrice.toFixed(2)),
    safetyCutOff,
    realEstateAgentFee,
    propertyTransferTax,
    notaryFee,
    equity: values.equity,
    availableAmountMonthly: values.availableAmountMonthly,
  };
};

export default calculateBudget;
